import React from 'react';

import { RelativeDate } from '@atlassian/bitkit-date';

import RenderedTitle from 'src/components/rendered-title';
import { Commit } from 'src/components/types';
import {
  UnmatchedCommitAuthorAvatar,
  UnmatchedCommitAuthorName,
  // Use these directly instead of `src/containers/user-{avatar,name}` to skip profile card and link behavior
  UserAvatar,
  UserName,
} from 'src/components/user-profile';

import * as styles from './commit-selector-item.style';

type Props = {
  commit: Commit;
  isSelected: boolean;
  onSelect: (commit: Commit) => void;
};

export default class CommitSelectorItem extends React.Component<Props> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    onSelect: () => {},
  };

  handleClick = () => {
    this.props.onSelect(this.props.commit);
  };

  renderAuthorAvatar() {
    const { commit } = this.props;
    return commit.author.user ? (
      <UserAvatar size="xsmall" user={commit.author.user} />
    ) : (
      // Do not pass `rawCommitAuthor` in, because we already provide the raw author's name
      // in the same UI context (via `<UnmatchedCommitAuthorName />`)
      <UnmatchedCommitAuthorAvatar size="xsmall" />
    );
  }

  renderAuthorName() {
    const { commit } = this.props;
    const { raw: rawAuthor, user } = commit.author;

    return user ? (
      <UserName user={user} />
    ) : (
      <UnmatchedCommitAuthorName rawCommitAuthor={rawAuthor} />
    );
  }

  render() {
    const { commit, isSelected } = this.props;

    const renderedMessage = commit.rendered && commit.rendered.message;

    return (
      <styles.CommitItem
        isSelected={isSelected}
        onClick={this.handleClick}
        testId={isSelected ? 'selected-commit' : undefined}
      >
        <styles.CommitSummary>
          <styles.Author>
            {this.renderAuthorAvatar()}
            <styles.AuthorName>{this.renderAuthorName()}</styles.AuthorName>
          </styles.Author>
          <RelativeDate date={commit.date} />
        </styles.CommitSummary>
        <styles.CommitMessage title={commit.message}>
          {renderedMessage ? (
            <RenderedTitle
              fadeLinesAfterFirst
              renderedContent={renderedMessage}
            />
          ) : (
            commit.message
          )}
        </styles.CommitMessage>
      </styles.CommitItem>
    );
  }
}
